import React from 'react';
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from 'react-responsive-carousel';
import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css';

import styles from './styles/gallery.module.css'
import BaseScreen from './BaseScreen';
import assets from './assets';
import { APP_NAME } from './constants';
import { useState } from 'react';

const images = assets.gallery;

function renderImages() {
	return images.map((asset, index) => {
		return <img alt={`${APP_NAME} Screenshot ${index}`} src={asset} />
	})
}


const Gallery = () => {
	const [isOpen, setIsOpen] = useState(false);
	const [photoIndex, setPhotoIndex] = useState(0);

	return (
		<BaseScreen>
			<div className={styles.container}>
				<h1>Gallery</h1>
				<Carousel
					infiniteLoop
					emulateTouch
					selectedItem={photoIndex}
					onClickItem={(index) => {
						setIsOpen(true)
						setPhotoIndex(index)
					}}
				>
					{renderImages()}
				</Carousel>
				{isOpen && (
					<Lightbox
						mainSrc={images[photoIndex]}
						nextSrc={images[(photoIndex + 1) % images.length]}
						prevSrc={images[(photoIndex + images.length - 1) % images.length]}
						onCloseRequest={() => {
							setIsOpen(false)
						}}
						onMovePrevRequest={() => {
							setPhotoIndex((photoIndex + images.length - 1) % images.length)
						}}
						onMoveNextRequest={() => {
							setPhotoIndex((photoIndex + 1) % images.length)
						}}
					/>
				)}
			</div>
		</BaseScreen>
	);
}

export default Gallery;

